import { SVGICON } from "../../constant/theme";

export const MenuList = [
    {
        title: 'Dashboard',
        iconStyle: SVGICON.MenuDashboard,
        to: '/dashboard',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Racks',
        iconStyle: SVGICON.MenuRack,
        to: '/rack',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Material',
        iconStyle: SVGICON.MenuMaterial,
        to: '/material',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Stock History',
        iconStyle: SVGICON.MenuStockHistory,
        to: '/stock_history',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Barcode',
        iconStyle: SVGICON.MenuBarcode,
        to: '/barcode',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Employee',
        iconStyle: SVGICON.MenuEmployee,
        to: '/employee',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Report',
        iconStyle: SVGICON.MenuReport,
        to: '/report',
        accessRole: ["Admin", "User"],
        permission_key: "view_report"
    },
    {
        title: 'User',
        iconStyle: SVGICON.MenuUsers,
        to: '/user',
        accessRole: ["Admin"],
        permission_key: null
    },
    {
        title: 'Reservation',
        iconStyle: SVGICON.MenuReservation,
        to: '/reservation',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Requisition',
        iconStyle: SVGICON.MenuRequisition,
        to: '/requisition',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Analysis',
        iconStyle: SVGICON.Charts,
        to: '/analysis',
        accessRole: ["Admin", "User"],
        permission_key: "view_analysis"
    },
    {
        title: 'Demand Forecast',
        iconStyle: SVGICON.Reports,
        to: '/demand-forecast',
        accessRole: ["Admin", "User"],
        permission_key: "view_demand_forecast"
    },
]